// Copyright (c) 2022 by Move Closer

import { ModalSizeMap } from '../../../../dsl/molecules/Modal'
import { AllowedAttributes } from '../../../../contexts'

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const PRODUCT_HEADER_COMPONENT_KEY = 'ProductHeaderComponent'

export interface ProductHeaderConfig {
  shouldDisplayRegularPriceForDiscount: boolean
  shouldDisplaySimplePrice: boolean
  shouldDisplayUnits: boolean
  badgesOnGallery: boolean
  badgeThemes: Record<string, string | undefined>
  favouriteAsIcon: boolean
  defaultMaxRating: number
  hasCertificates: boolean
  hasDefaultVariantSelector: boolean
  hasDeliveryTimer: boolean
  hasGiftsBox: boolean
  hasOrderDetails: boolean
  hasVariantDetailsAttributes: boolean
  icons: Record<string, string>
  promotionBadgeHasLabel: boolean
  previousPriceConfig: Record<string, unknown>
  variantSwitcherShowChosen: boolean
  modalSize: ModalSizeMap
  useDrawer: boolean
  useVendorReviews: boolean
  shouldHaveSeparatedRating: boolean
  shouldHaveVisibleRating: boolean
  showSingleVariantRating: boolean
  isVariantNameEnabled: boolean
  isNewBadgeSquare: boolean // todo: refactor - badge powinny byc w calosci konfigurowalne
  shouldDisplayApplication: boolean
  shouldDisplayReviewWithDescription: boolean
  shouldDisplayDiscount: boolean
  shouldDisplayMilesAndMore: boolean
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const PRODUCT_HEADER_DEFAULT_CONFIG: ProductHeaderConfig = {
  badgesOnGallery: false,
  badgeThemes: {
    [AllowedAttributes.IsNew]: undefined,
    [AllowedAttributes.IsSale]: undefined,
    [AllowedAttributes.IsBestseller]: undefined
  },
  favouriteAsIcon: false,
  defaultMaxRating: 5,
  hasCertificates: false,
  hasDefaultVariantSelector: false,
  hasDeliveryTimer: false,
  hasGiftsBox: false,
  hasOrderDetails: false,
  hasVariantDetailsAttributes: true,
  icons: {
    addToCartButtonIcon: '',
    heartEmptyIcon: 'HeartEmptyIcon',
    heartFullIcon: 'HeartFullIcon',
    infoIcon: 'InfoIcon',
    notifyButtonIcon: ''
  },
  promotionBadgeHasLabel: false,
  previousPriceConfig: {
    priceBeforeDiscount: true,
    previousPrice: true,
    showPercentageDiscount: true
  },
  variantSwitcherShowChosen: false,
  modalSize: ModalSizeMap.Medium,
  useDrawer: false,
  useVendorReviews: false,
  shouldHaveSeparatedRating: false,
  shouldHaveVisibleRating: true,
  showSingleVariantRating: false,
  isVariantNameEnabled: false,
  isNewBadgeSquare: false, // todo: refactor - badge powinny byc w calosci konfigurowalne
  shouldDisplayApplication: true,
  shouldDisplayReviewWithDescription: true,
  shouldDisplayDiscount: false,
  shouldDisplayMilesAndMore: false,
  shouldDisplayRegularPriceForDiscount: false,
  shouldDisplaySimplePrice: true,
  shouldDisplayUnits: true
}
